import dynamic from "next/dynamic";
import { useRouter } from "next/router";

import { useCallback } from "react";

import { twMerge } from "tailwind-merge";

import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";

import EntityPageData from "components/EntityPageLayout/EntityPageData";
import FontAwesomeIcon from "components/FontAwesomeIcon";
import TopNavBarMobile from "components/TopNavBar/TopNavBarMobile";
import useMediaQuery from "hooks/useMediaQuery";

import styles from "./style.module.scss";

const Modal = dynamic(() => import("react-modal"));

type EntityDataModalProps = {
  slug: string;
  isOpen: boolean;
  onClose?: () => void;
};

const EntityDataModal = ({ slug, isOpen, onClose }: EntityDataModalProps) => {
  const router = useRouter();
  const { mobile } = useMediaQuery();

  const toggleModal = useCallback(() => {
    if (onClose) {
      return onClose();
    }

    router.back();
  }, [onClose, router]);

  return (
    <Modal
      portalClassName={styles.modal}
      overlayClassName={styles.overlay}
      className={twMerge(
        styles.content,
        mobile ? styles.mobileLayout : styles.desktopLayout
      )}
      isOpen={isOpen}
      shouldCloseOnEsc
      onRequestClose={toggleModal}
      shouldFocusAfterRender
      closeTimeoutMS={500}
      onAfterOpen={() => {
        document.body.style.overflowY = "hidden";
      }}
      onAfterClose={() => {
        document.body.style.overflowY = "";
      }}
    >
      {mobile ? (
        <TopNavBarMobile onGoBack={toggleModal} />
      ) : (
        <div className={styles.actionsBar}>
          <FontAwesomeIcon
            icon={faTimes}
            className={styles.closeButton}
            onClick={toggleModal}
          />
        </div>
      )}
      <div className={"overflow-y-auto"}>
        <EntityPageData slug={slug} isModal />
      </div>
    </Modal>
  );
};

export default EntityDataModal;
